export default "__VITE_ASSET__CQmJhTzY__"